<template>
  <div class="reset-bg">
    <div class="reset-header d-flex">
      <div class="reset-header-logo" @click="reBack">
        <img src="@/assets/img/base/logo.png">
      </div>
      <div class="black-14">找回密码</div>
    </div>
    <div class="reset-form">
     <div class="reset-process d-flex-center">
       <div class="reset-process-block"><div>1</div><div>验证手机</div></div>
       <img src="@/assets/img/login/line.png">
       <div class="reset-process-block" :class="resetStep > 1 ? '' : 'disClick'"><div>2</div><div>重置密码</div></div>
       <img src="@/assets/img/login/line.png">
       <div class="reset-process-block" :class="resetStep > 2 ? '' : 'disClick'"><div>3</div><div>成功</div></div>
     </div>
      <template v-if="resetStep == 1">
        <div class="reset-title">验证手机号</div>
        <div class="input-line mt-32" :data-attr="toastInfo.telephone">
          <input v-model="telephone" placeholder="请输入手机号" type="text" @input="inputChange($event,'telephone')">
        </div>
        <div class="input-line" :data-attr="toastInfo.code">
          <input v-model="code" placeholder="请输入验证码" type="text" @input="inputChange($event,'code')">
          <div :class="toastInfo.telephone == '' && getCodeText == '获取验证码'? '' : 'dis-bg'" class="input-code-btn black-14" @click.stop="getCode">
            {{ getCodeText }}
          </div>
        </div>
        <div class="submit-btn black-14" @click="submitForm(1)" :class="isRight ? '' : 'dis-bg'">下一步</div>
      </template>
      <template v-if="resetStep == 2">
        <div class="reset-title">重置密码</div>
        <div class="input-line mt-32" :data-attr="toastInfo.password">
          <input  v-model="password" placeholder="请输入新密码" type="password" @input="inputChange($event,'password')">
        </div>
        <div class="input-line" :data-attr="toastInfo.rePassword">
          <input v-model="rePassword" placeholder="请再次输入新密码" type="password" @input="inputChange($event,'rePassword')">
        </div>
        <div class="submit-btn black-14" @click="submitForm(2)" :class="isRight ? '' : 'dis-bg'">确认重置密码</div>
      </template>
      <template v-if="resetStep == 3">
        <img class="reset-ok" src="@/assets/img/login/resetOk.png" alt="">
        <div class="reset-title">重置密码成功</div>
        <div style="margin-top: 50px" class="submit-btn black-14" @click="submitForm(3)">返回登录</div>
      </template>
    </div>
  </div>
</template>

<script>
import {sendSmsCode} from "@/http/login";
import {Login, Logout} from "@/http/api";
import {modifyPassword} from "@/http/user_center";

export default {
  name: "reset",
  data(){
    return{
      telephone: '',
      code: '',
      password:'',
      rePassword:'',
      toastInfo:{
        telephone:null,
        code:null,
        password:null,
        rePassword:null
      },
      isRight:false,
      resetStep:1,
      getCodeText:'获取验证码',
      token:''
    }
  },
  methods:{
    submitForm(step){
      if(step == 1){
        Login({from:'pc',telephone: this.telephone,code:this.code}).then(res=>{
          if(res.code == 200){
            this.resetStep = 2
            this.isRight = false
            this.token = res.data.token
          }else{
            this.$message({
              type:'error',
              message:res.message[0]
            })
          }
        })
      }else if(step == 2){
        if(this.password != this.rePassword){
          this.$message({
            type:'info',
            message:'两次输入密码不一致'
          })
        }else{
          modifyPassword({password: this.rePassword,token:this.token}).then(res=>{
            if(res.code == 200){
              this.resetStep = 3
            }else{
              this.$message({
                type:'error',
                message:res.message[0]
              })
            }
          })
        }
      }else{
          this.$router.push('/login')
      }
    },
    getCode() {
      let m = 60
      let _that = this
      sendSmsCode({ telephone: this.telephone }).then((res) => {
        if (res.code == 200) {
          let timer = setInterval(()=>{
            if(m <= 0){
              _that.getCodeText = '获取验证码'
              clearInterval(timer)
            }else{
              _that.getCodeText = '重新获取' + (--m) + 's'
            }
          },1000)
        } else {
          this.$message.error(res.message[0] ? res.message[0] : "发送失败");
        }
      });
    },
    inputChange(e,type){
      if(type == 'code'){
        if(this.code.length == 4) this.toastInfo.code = ''
        else this.toastInfo.code = '请输入4位验证码'
      }else if(type == 'password'){
        if(this.password.trim() != '') this.toastInfo.password = ''
        else this.toastInfo.password = '请输入新密码'
      }else if(type == 'rePassword'){
        if(this.rePassword.trim() == '') this.toastInfo.rePassword = '请再次输入新密码'
        else this.toastInfo.rePassword = ''
      }else{
        if(!(/^1[3456789]\d{9}$/.test(this.telephone))) this.toastInfo.telephone = '请输入正确的手机号'
        else this.toastInfo.telephone = ''
      }
      if(this.resetStep == 2 && this.toastInfo.password == '' && this.toastInfo.rePassword == '' && this.rePassword.trim() != '' && this.password.trim() != '') this.isRight = true
      else if(this.resetStep == 1 && this.toastInfo.telephone == '' && this.toastInfo.code == '') this.isRight = true
      else this.isRight = false
    },
    reBack(){
      localStorage.setItem('token',false)
      localStorage.setItem('member',false)
      Logout().then(() => {
        localStorage.setItem('member', '')
        localStorage.setItem('token','')
        window.location.href = "/login";
      }).catch(()=>{
        localStorage.setItem('member', '')
        localStorage.setItem('token','')
        window.location.href = "/login";
      });
    }
  }
}
</script>

<style scoped src="../../assets/css/login.css"></style>
<style>
.input-line::after{
  content: attr(data-attr);
  color: #FED400;
  font-size: 12px;
  position: relative;
  top: -5px;
}
</style>
